import validate from "/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import _010_45iframe_45headers_45global from "/frontend/middleware/010.iframe-headers.global.js";
import _011_45auth_45global from "/frontend/middleware/011.auth.global.js";
import _013_45redirect_45to_45login_45global from "/frontend/middleware/013.redirect-to-login.global.js";
import _014_45supported_45affiliate_45route_45guard_45global from "/frontend/middleware/014.supported-affiliate-route-guard.global.js";
import _015_45redirects_45global from "/frontend/middleware/015.redirects.global.js";
import _016_45test_45page_45guard_45global from "/frontend/middleware/016.test-page-guard.global.js";
import _018_45embedded_45route_45guard_45global from "/frontend/middleware/018.embedded-route-guard.global.js";
import _020_45pusher_45global from "/frontend/middleware/020.pusher.global.js";
import _07_45prevent_45server_45side_45response_45caching_45global from "/frontend/middleware/07.prevent-server-side-response-caching.global.js";
import _070_45cobrand_45global from "/frontend/middleware/070.cobrand.global.js";
import _08_45is_45cypress_45test_45global from "/frontend/middleware/08.is-cypress-test.global.js";
import _09_45router_45logging_45global from "/frontend/middleware/09.router-logging.global.js";
import _090_45token_45expiration_45global from "/frontend/middleware/090.token-expiration.global.js";
export const globalMiddleware = [
  validate,
  _010_45iframe_45headers_45global,
  _011_45auth_45global,
  _013_45redirect_45to_45login_45global,
  _014_45supported_45affiliate_45route_45guard_45global,
  _015_45redirects_45global,
  _016_45test_45page_45guard_45global,
  _018_45embedded_45route_45guard_45global,
  _020_45pusher_45global,
  _07_45prevent_45server_45side_45response_45caching_45global,
  _070_45cobrand_45global,
  _08_45is_45cypress_45test_45global,
  _09_45router_45logging_45global,
  _090_45token_45expiration_45global
]
export const namedMiddleware = {
  "019-embedded-redirects": () => import("/frontend/middleware/019.embedded-redirects.js"),
  "anonymous-user-experiments": () => import("/frontend/middleware/anonymous-user-experiments.js"),
  "app-experience-config-page": () => import("/frontend/middleware/app-experience-config-page.js"),
  "check-403": () => import("/frontend/middleware/check-403.js"),
  "document-upload-request": () => import("/frontend/middleware/document-upload-request.js"),
  "embedded-page": () => import("/frontend/middleware/embedded-page.js"),
  "params-to-cookies": () => import("/frontend/middleware/params-to-cookies.js"),
  "resume-app": () => import("/frontend/middleware/resume-app.js"),
  "transitions-helper": () => import("/frontend/middleware/transitions-helper.js")
}